import inv from '../images/invest.svg'

export const invest = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Invierte en el futuro',
  headline: 'La horticultura futurista está aquí',
  description:
    'Ofrecemos comodos planes de inversión. Ya contamos con patrocinantes y nuestros charts hablan por nosotros. El futuro es ahora.',
  buttonLabel: 'Invertir',
  linkTo: 'signup',
  imgStart: 'start',
  img: inv,
  alt: 'Data'
};